<template>
  <div class="AddCourse">
    <AppHeader v-if="isAdd" :content="isAddContent"></AppHeader>
    <AppHeader v-else :content="isEditContent"></AppHeader>
    <AppBox class="appBox">
      <h5>基础信息</h5>
      <div class="lineStyle"></div>
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <div
            style="
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <el-form-item label="课程标题" prop="name">
            <el-input
                style="width: 350px"
                v-model="formData.name"
                maxlength="20"
                placeholder="不得超过20个文字"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 100px" label="课程标签">
            <AppTreeSelect
                style="width: 250px"
                :options="options"
                :valueArr="formData.tagValueIdList"
                @tagChange="tagChange"
            ></AppTreeSelect>
          </el-form-item>
        </div>
        <el-form-item label="课程类型" prop="category">
          <el-select
              style="width: 350px"
              v-model="formData.category"
              placeholder="请选择"
              @change="handleChange"
          >
            <el-option
                v-for="item in courseTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系列名称">
          <el-input
              style="width: 350px"
              :disabled="true"
              v-model="formData.classSubjectName"
          ></el-input>
        </el-form-item>
        <el-form-item label="老师称呼" prop="nickname">
          <el-input style="width: 350px" v-model="formData.nickname"></el-input>
        </el-form-item>
        <el-form-item label="老师头像">
          <div class="img-container" v-if="formData.materialUrl">
            <img :src="formData.materialUrl" class="avatar" alt=""/>
          </div>
          <AppUpload
              :materialUrl="formData.materialUrl"
              @beforeUpload="beforeUpload"
              ref="child"
              @afterUpload="afterUpload"
              @onConfirmPickMaterial="onConfirmPickMaterial"
          ></AppUpload>
        </el-form-item>
        <el-form-item label="学习目标"></el-form-item>
        <el-form-item
            label="目标1"
            :prop="formData.category === 0 ? 'target[0]' : ''"
        >
          <el-input
              placeholder="不得超过28个文字"
              style="width: 50%"
              maxlength="28"
              v-model="formData.target[0]"
              :clearable="true"
              show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="目标2">
          <el-input
              placeholder="不得超过28个文字"
              style="width: 50%"
              maxlength="28"
              v-model="formData.target[1]"
              :clearable="true"
              show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button v-if="formData.id" style="width: 10%" type="primary" @click="handleSaveConfirm"
        >保存
        </el-button>
        <el-button style="width: 10%" type="primary" @click="handleConfirm"
        >下一步
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import {courseMixins} from "@/pages/CourseManagement/courseMixins";
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppUpload from "@/components/ui/AppUpload/index.vue";
import {mapActions, mapState} from "vuex";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";

export default {
  name: "AddCourse",
  components: {MaterialPicker, AppTreeSelect, AppUpload, AppHeader, AppBox},
  mixins: [courseMixins],
  data() {
    return {
      isAdd: true,
      isAddContent: "课程管理 | 新增课程",
      isEditContent: "课程管理 | 编辑课程",
      courseTypeOption: [
        {value: 0, label: "互动课程"},
        {value: 1, label: "特色课程"},
      ],
    };
  },
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
    if (this.$route.params.type === "add") {
      const isActive = JSON.parse(localStorage.getItem("isActive"));
      if (isActive === "isTrue") {
        const detail = JSON.parse(localStorage.getItem("lessonResponseDetail"));
        Object.keys(this.formData).map((key) => {
          this.formData[key] = detail[key];
        });
      } else {
        this.clearForm();
        this.isAdd = true;
      }
    }
    if (this.$route.params.type === "edit") {
      const isActive = JSON.parse(localStorage.getItem("isActive"));
      if (isActive === "isFalse") {
        this.isAdd = false;
      }
      const detail = JSON.parse(localStorage.getItem("lessonResponseDetail"));
      Object.keys(this.formData).map((key) => {
        this.formData[key] = detail[key];
      });
    } else {
      let userConfig = await this.getUserConfig({type: "lesson_default_config"});
      this.formData.nickname = userConfig.data.nickname;
      this.formData.avatarId = userConfig.data.avatarId;
      this.formData.materialUrl = userConfig.data.avatarUrl;
    }
  },
  methods: {
    ...mapActions("courseCenter", ["getTagCategoryList", "getUserConfig"]),
    onConfirmPickMaterial(item) {
      this.formData.avatarId = item.id;
      this.formData.materialUrl = item.url;
    },
    handleChange() {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    tagChange(val) {
      this.formData.tagValueIdList = val;
    },
    // 上传之前
    beforeUpload(file, callback) {
      const isJPG =
          file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        callback(false); // 不执行下面的事件
      } else {
        callback(true); // 执行下面的事件
      }
    },
    //   上传成功之后
    afterUpload(materialUrl, material) {
      this.formData.materialUrl = materialUrl;
      this.formData.material = material;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddCourse {
  //position: relative;

  .appBox {
    min-height: calc(100vh - 155px);

    .lineStyle {
      width: 100%;
      height: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
    }

    .targetBox {
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .img-container {
      width: 70px;
      height: 70px;
      overflow: hidden;
      border-radius: 50%;

      .avatar {
        width: auto;
        height: auto;
        max-width: 70px;
        max-height: 70px;
        min-width: 70px;
        min-height: 70px;
        object-fit: cover;
        object-position: center;
      }
    }

    .footer {
      margin-top: 50px;
      //position: absolute;
      text-align: center;
      //bottom: 100px;
      //right: 50px;
      //left: 50px;
    }
  }
}
</style>
